import React from 'react';

type TBulkDisplayItems = {
    countOfSelected: number;
    isFreelancersRoot: boolean;
};

export function BulkDisplayItems({
    countOfSelected,
    isFreelancersRoot,
}: TBulkDisplayItems) {
    return (
        <div className="bookings-bulk-actions__details">
            <div>
                {countOfSelected}
                {isFreelancersRoot ? ' worker' : ' job'}
                {countOfSelected !== 1 ? 's' : ''} selected
            </div>
        </div>
    );
}
